<div class="row align-items-center">
    <div class="col-md-6">
        <app-page-title [title]="'Personal Information'"></app-page-title>
    </div>
    <div class="col-md-6 ">
        <p class="text-uppercase">{{selectChildTermName$ | async }} Account: {{childUserAccountEmail}}</p>
    </div>
</div>
<div class="form-container">
    <div class="row">
        <div class="col-md-12">
            <app-proof-of-identity
                *ngIf="personalLookupInfo"
                [userAccountId]="userAccountId"
                [personalLookupInfo]="personalLookupInfo"
                [forChildReadOnlyFields]="true"
                (formSubmit)="onProofOfIdentityFormSubmit($event)"
            ></app-proof-of-identity>
        </div>
    </div>
    <br />
    <br />
    <ng-container *ngIf="childAccountAddress">
        <div class="row">
            <div class="col-md-12">
                <h4>SHIPPING & BILLING ADDRESS</h4>
            </div>

            <div
                class="col-md-12"
                *ngIf="childAccountAddress"
            >
                <div class="checkbox">
                    <input
                        type="checkbox"
                        [(ngModel)]="childAccountAddress.areShippingBillingAddressSame"
                        name="areShippingBillingAddressSame"
                    />
                    Same shipping and billing address
                </div>
                <br>
            </div>
        </div>


        <div
            class="row"
            *ngIf="countries"
        >
            <div class="col-md-6">
                <app-address-form
                    [submitted]="submitted"
                    [address]="childAccountAddress.shippingAddress"
                    [heading]="(childAccountAddress.areShippingBillingAddressSame) ? 'Shipping/Billing Address' : 'Shipping Address'"
                    [countries]="countries"
                    (formValueChanged)="shippingFormValueChanged($event)"
                ></app-address-form>
            </div>
            <div class="col-md-6">
                <app-address-form
                    *ngIf="!childAccountAddress.areShippingBillingAddressSame"
                    [submitted]="submitted"
                    [address]="childAccountAddress.billingAddress"
                    [heading]="(childAccountAddress.areShippingBillingAddressSame) ? 'Shipping/Billing Address' : 'Billing Address'"
                    [countries]="countries"
                    (formValueChanged)="billingFormValueChanged($event)"
                ></app-address-form>
            </div>
        </div>

    </ng-container>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <a
                    (click)="onSubmit()"
                    class="btn btn-primary m-1"
                >Save</a>
                <a
                    [routerLink]="['/my-account']"
                    class="btn btn-secondary m-1"
                >Back to My Account</a>
            </div>
        </div>
    </div>
</div>
